import { useState, useEffect } from "react";


export function RegisterPage1({ setPage, errors, userData, setUserData }) {

  const handleRegister = () => {
    setPage(2);
  }

  const[nameMissing, setNameMissing] = useState();
  const[surname1Missing, setSurname1Missing] = useState();
  const[surname2Missing, setSurname2Missing] = useState();
  const[emailMissing, setEmailMissing] = useState();
  const[emailTaken, setEmailTaken] = useState();
  const[emailFormat, setEmailFormat] = useState();

  useEffect(() => {
    if (errors.nameMissing) {
      setNameMissing("El nombre es obligatorio");
    } else {
      setNameMissing("");
    }
  }, [errors.nameMissing]);

  useEffect(() => {
    if (errors.surname1Missing) {
      setSurname1Missing("El apellido es obligatorio");
    } else {
      setSurname1Missing("");
    }
  }, [errors.surname1Missing]);

  useEffect(() => {
    if (errors.surname2Missing) {
      setSurname2Missing("El apellido es obligatorio");
    } else {
      setSurname2Missing("");
    }
  }, [errors.surname2Missing]);

  useEffect(() => {
    if (errors.emailMissing) {
      setEmailMissing("El email es obligatorio");
    } else {
      setEmailMissing("");
    }
  }, [errors.emailMissing]);

  useEffect(() => {
    if (errors.emailTaken) {
      setEmailTaken("El email está en uso");
    } else {
      setEmailTaken("");
    }
  }, [errors.emailTaken]);

  useEffect(() => {
    if (errors.emailFormat) {
      setEmailFormat("El email está en uso");
    } else {
      setEmailFormat("");
    }
  }, [errors.emailFormat]);

  const handleNameChange = (event) => {
    const newName = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      name: newName,
    }));
  };

  const handleSurname1Change = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      surname1: newData,
    }));
  };

  const handleSurname2Change = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      surname2: newData,
    }));
  };

  const handleEmailChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      email: newData,
    }));
  };

  const handleMobileChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      mobile: newData,
    }));
  };

  return (
    <>                      
      <div className="m-frmGroup">
       Nombre
        <div className="m-frmGroup is-error">
          <div id="name_missing" className="a-msg " >
            {nameMissing}
          </div>
        </div> 
    
        <input 
          type="text" 
          name="name" 
          id="name" 
          placeholder="Escribe tu nombre" 
          required="required"
          value={userData.name}
          onChange={handleNameChange}/>
      </div>

      <div className="m-frmGroup">
        Primer apellido
        <div className="m-frmGroup is-error">
          <div id="surname1_missing" className="a-msg " >
            {surname1Missing}
          </div>
        </div> 
        <input 
          type="text" 
          name="surname1" 
          id="surname1" 
          placeholder="Escribe tu primer apellido" 
          required="required"
          value={userData.surname1}
          onChange={handleSurname1Change}
          />     
      </div>

      <div className="m-frmGroup">
        Segundo apellido
        <div className="m-frmGroup is-error">
          <div id="surname2_missing" className="a-msg " >
            {surname2Missing}
          </div>
        </div>
        <input 
          type="text" 
          name="surname2" 
          id="surname2" 
          placeholder="Escribe tu segundo apellido" 
          required="required"
          value={userData.surname2}
          onChange={handleSurname2Change}
        />
      </div>

      <div className="m-frmGroup">
        Email
        <div className="m-frmGroup is-error">
          <div id="email_missing" className="a-msg ">
            {emailMissing}
            {emailTaken}
            {emailFormat}
          </div>
        </div>
        
        <input 
          type="text" 
          name="email" 
          id="email" 
          placeholder="Email" 
          required="required"
          value={userData.email}
          onChange={handleEmailChange}
        />
      </div>

      <div className="m-frmGroup">
        Teléfono
        <input 
          type="text" 
          name="phone" 
          id="phone" 
          placeholder="Teléfono" 
          required="required"
          value={userData.mobile}
          onChange={handleMobileChange}/>
      </div>

      <br/>
      <div className="row content-flex-end">
      <div className="btnBlue-l btnArrow-l float-right"  onClick={() => handleRegister()}  >Registrate </div>
      </div>


    </>
  )}